// @ts-nocheck

import { reduce, size } from 'lodash';
import { createSelector } from 'reselect';

import { Target } from '../../client';
import {
  selectBasketCachedMMAPIResponsesInfos,
  selectBasketIsCashout,
  selectBasketItemsMemoizedForSelection,
  selectBasketMode,
  selectBasketStatus,
} from '../../selectors/basket/basketPrimary.selector';
import {
  selectBasketTotalCost,
  selectBasketShowResume,
  selectBasketIsSummaryKeyboardVisible,
} from '../../selectors/basketCommon.selector';
import { selectBasketEnhancedItems, selectBasketNbItemInError } from '../../selectors/basketItems.selector';
import { selectEntitiesBetslips } from '../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectRuntimeIsCashoutEnabled, selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserConnected } from '../../selectors/user/userPrimary.selector';
import { BasketStatuses } from '../../types/basket';
import { BasketModes } from '../../types/basket';
import { createShallowEqualSelector } from '../../utils/reselect';
import isHistory from '../../utils/routes/isHistory';

const getCashoutValue = createShallowEqualSelector([selectEntitiesBetslips], (betslips) => {
  return reduce(
    betslips,
    (prev, curr) => {
      return prev + (curr?.cashoutValue || 0);
    },
    0,
  );
});

const getIsButtonDisable = (showAcceptChangebutton, isCashout, totalCost, items, mmCacheByMatchId, basketMode) => {
  const isAllItemsCashout = reduce(items, (curr, prev) => curr && !!prev?.cashout, true);

  return (
    (isCashout && isAllItemsCashout) ||
    showAcceptChangebutton ||
    totalCost <= 0 ||
    (basketMode !== BasketModes.SIMPLE &&
      !!items.find((item) => mmCacheByMatchId[item.matchId]?.result?.mymatchError?.errorId))
  );
};

const getLocationPathname = (state, { history }) => history?.location?.pathname;

export const getHasSummaryPresets = createSelector([selectBasketMode, selectBasketEnhancedItems], (mode, items) => {
  const isModeSimple = mode === BasketModes.SIMPLE;
  const isMultipleSimpleBets = isModeSimple && items.length > 1;
  return !isMultipleSimpleBets || !isModeSimple;
});

const selectBasketCtasProps = createSelector(
  [
    selectUserConnected,
    selectRuntimeIsCashoutEnabled,
    selectBasketItemsMemoizedForSelection,
    selectBasketIsCashout,
    selectBasketStatus,
    selectBasketEnhancedItems,
    selectBasketShowResume,
    selectBasketNbItemInError,
    selectBasketTotalCost,
    getCashoutValue,
    getLocationPathname,
    selectBasketIsSummaryKeyboardVisible,
    getHasSummaryPresets,
    selectRuntimeLicence,
    selectBasketCachedMMAPIResponsesInfos,
    selectBasketMode,
  ],
  (
    connected,
    isCashoutEnabled,
    itemsMemoizedForSelection,
    isCashout,
    status,
    items,
    showResume,
    nbItemInError,
    totalCost,
    basketCashoutValue,
    locationPathname,
    isSummaryKeyboardVisible,
    hasSummaryPresets,
    licence,
    cachedMMAPIResponsesInfos,
    basketMode,
  ) => {
    const isValidating = BasketStatuses.PENDING === status;
    const showAcceptChangebutton = reduce(items, (acc, { changed }) => acc || !!changed, false);

    const isButtonDisable = getIsButtonDisable(
      showAcceptChangebutton,
      isCashout,
      totalCost,
      items,
      cachedMMAPIResponsesInfos,
      basketMode,
    );
    const nbItemsMemoized = size(itemsMemoizedForSelection);

    const showCashoutButton =
      !Target.__MOBILE__ && items.length === 0 && isCashoutEnabled && connected && !isHistory(locationPathname);
    const cashoutValue = showCashoutButton ? basketCashoutValue : null;
    const isEmpty = items.length === 0;

    return {
      isEmpty,
      showResume,
      nbItemInError,
      nbItemsMemoized,
      connected,
      isCashout,
      totalCost,
      cashoutValue,
      showAcceptChangebutton,
      isButtonDisable,
      isValidating,
      isMobile: Target.__MOBILE__,
      hasSummaryPresets,
      licence,
    };
  },
);

export default selectBasketCtasProps;
